import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormModalShell from "../ui/form-modal-shell";
import { FormSelectRow } from "./form-select-row";
import {
  CourierActions,
  CourierCheck,
  CourierReadonly,
  CourierText
} from "../ui/courier-fields";
import { getCollectionCentersAPI } from "../../../api/location";

const EditCenterForm = ({
  center,
  zones = [],
  centerTypes = [],
  closeModal,
  loading,
  apiError,
  updateCourierCenter
}) => {
  const [zoneId, setZoneId] = useState(center.zone || "");
  const [collectionCenters, setCollectionCenters] = useState([]);

  useEffect(() => {
    setZoneId(center.zone || "");
  }, [center]);

  useEffect(() => {
    const zone = zones.find(z => String(z.id) === String(zoneId));
    if (!zone?.region) {
      setCollectionCenters([]);
      return;
    }
    getCollectionCentersAPI({ regionId: zone.region }).then(resp => {
      if (resp?.data) {
        setCollectionCenters(Array.isArray(resp.data) ? resp.data : []);
      }
    });
  }, [zoneId, zones]);

  return (
    <FormModalShell title="Edit Center" apiError={apiError} onClose={closeModal} columns={3}>
      <Formik
        enableReinitialize
        initialValues={{
          zone: center.zone || "",
          centerType: center.centerType || "",
          collectionCenter: center.collectionCenter || "",
          name: center.name || "",
          address: center.address || "",
          latitude: center.latitude || "",
          longitude: center.longitude || "",
          contactPerson: center.contactPerson || "",
          contactNumber: center.contactNumber || "",
          isActive: center.isActive !== false
        }}
        validationSchema={Yup.object().shape({
          zone: Yup.string().required("Required field"),
          centerType: Yup.string().required("Required field"),
          name: Yup.string().required("Required field"),
          latitude: Yup.string().required("Required field"),
          longitude: Yup.string().required("Required field")
        })}
        onSubmit={values => {
          updateCourierCenter({
            id: center.id,
            data: {
              name: values.name,
              address: values.address,
              latitude: values.latitude,
              longitude: values.longitude,
              contactPerson: values.contactPerson,
              contactNumber: values.contactNumber,
              zone: Number(values.zone),
              centerType: Number(values.centerType),
              collectionCenter: values.collectionCenter
                ? Number(values.collectionCenter)
                : null,
              isActive: values.isActive
            }
          });
        }}
      >
        {formik => (
          <Form>
            <CourierReadonly label="Code" value={center.code} />
            <FormSelectRow
              label="Zone"
              name="zone"
              value={formik.values.zone}
              onChange={e => {
                formik.setFieldValue("zone", e.target.value);
                setZoneId(e.target.value);
              }}
              error={formik.touched.zone && formik.errors.zone}
              required
              options={zones.map(z => ({ value: z.id, label: z.name }))}
            />
            <FormSelectRow
              label="Center Type"
              name="centerType"
              value={formik.values.centerType}
              onChange={e =>
                formik.setFieldValue("centerType", e.target.value)
              }
              error={formik.touched.centerType && formik.errors.centerType}
              required
              options={centerTypes.map(t => ({
                value: t.id,
                label: `${t.name}${t.isSpecial ? " (special)" : ""}`
              }))}
            />
            <FormSelectRow
              label="Collection Center (optional)"
              name="collectionCenter"
              value={formik.values.collectionCenter}
              onChange={e =>
                formik.setFieldValue("collectionCenter", e.target.value)
              }
              placeholder="Manual / none"
              options={collectionCenters.map(c => ({
                value: c.id,
                label: c.name
              }))}
            />
            <CourierText label="Display Name" name="name" />
            <CourierText label="Contact Person" name="contactPerson" />
            <CourierText label="Contact Number" name="contactNumber" />
            <CourierText label="Address" name="address" span />
            <CourierText label="Latitude" name="latitude" />
            <CourierText label="Longitude" name="longitude" />
            <CourierCheck
              label="Active"
              checked={formik.values.isActive}
              onChange={e =>
                formik.setFieldValue("isActive", e.target.checked)
              }
            />
            <CourierActions
              loading={loading}
              submitLabel="Save Changes"
              onCancel={closeModal}
            />
          </Form>
        )}
      </Formik>
    </FormModalShell>
  );
};

export default EditCenterForm;
